import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import EBPMask from "@/components/workbean-page/culture/EbgImageObject.vue"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'EbpImage',
  props: {
    data: {
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      default() {},
      type: Object,
    },
  },
  setup(__props) {

const props = __props;

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "flex flex-shrink-0 flex-grow-0 mx-2 rounded-base justify-center",
    style: _normalizeStyle({
      background: `${__props.data.color}`,
    })
  }, [
    _createVNode(EBPMask, {
      class: "w-40 my-auto mx-0",
      label: props.data.label,
      color: "#ffffff"
    }, null, 8, ["label"]),
    _renderSlot(_ctx.$slots, "default")
  ], 4))
}
}

})